import { render, staticRenderFns } from "./CartExerptProduct.vue?vue&type=template&id=0fba42a8&scoped=true&"
import script from "./CartExerptProduct.vue?vue&type=script&lang=js&"
export * from "./CartExerptProduct.vue?vue&type=script&lang=js&"
import style0 from "./CartExerptProduct.vue?vue&type=style&index=0&id=0fba42a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba42a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IClose: require('/opt/build/repo/components/svg/Close.vue').default,AirtableImage: require('/opt/build/repo/components/AirtableImage.vue').default})
